import { useContext, useEffect, useState } from "react";
import BaseUrl from "../../../utils/BaseUrl";
import CustomerStyle from "../../../utils/customerStyle";
import ContentPage from "../../Content";
import separateNumber from "../../../utils/separateur";
import axios from "axios";
import DataTable from "react-data-table-component";
import ExportExcel from "../../../utils/ExcelExport";
import DetailSitesPage from "./detail_sites_page";
import { UserContext } from "../../../utils/User_check";
import { useNavigate } from "react-router-dom";
import can from "../../../utils/Can";

const url = BaseUrl();
const customerStyle = CustomerStyle();
function PerformanceMomo(){
      const [itemsListCcl,setItemsListCcl] = useState([]);
      const [itemsList,setItemsList] = useState([]);
      const [itemsListFilterCcl,setItemsListFilterCcl] = useState([]);
      const [itemsListFilter,setItemsListFilter] = useState([]);
      const [loading, setLoading] = useState(false);
      const [newComponent,setNewComponent] = useState('list');
      const [item,setItem] = useState(null);
      const [activeClass,setActiveClass] = useState('ccl');


      const columns = [
        {
          name: "SITE",
          selector : row => row.Site
        },
        {
            name: "PRINCIPAL",
            selector : row => row.EstPrincipal
          },
        {
          name: "FDR COMMERCIAUX",
          selector : row => <b className="text-dark">{separateNumber(row.FondDeRoulementCommerciaux)}</b>
        },
        {
          name: "FDR GESITES",
          selector : row => <b className="text-dark">{separateNumber(row.FondDeRoulementGesite)}</b>
        },

        {
            name: "FDR SITES",
            selector : row => <b className="text-success">{separateNumber(parseInt(row.FondDeRoulementCommerciaux) + parseInt(row.FondDeRoulementGesite) )}</b>
          },
    
        {
          name: "ACTION",
          selector : row => (
            <>
            <button className="btn btn-primary p-2" onClick={()=> chanhePageFunction(row)}>Voir plus</button>
           
            </>
          )
        },
    
    
    
    ];
    const {user,role, permissions} = useContext(UserContext);
    const navigate = useNavigate();
    useEffect(()=>{
      if(user && permissions && !can(permissions,'PERFORMANCE EVD ET MOMO')){
          navigate('/page-no-found');
      }
  },[user]);
    useEffect(()=>{
        fetchItemsList();
      },[]);
      const fetchItemsList = async ()=>{
        setLoading(true);
        try {
            axios.get(url.base+'/get_performance_momo_api',{
                headers:{
                    'Content-Type':'application/json',
                    "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                    
                },
            }).then((resp)=>{
    
                if(resp.status == 200){
                    setItemsList(resp.data.Bysecteurs);
                    setItemsListFilter(resp.data.Bysecteurs);

                    setItemsListCcl(resp.data.Bycommerciaux);
                    setItemsListFilterCcl(resp.data.Bycommerciaux);
                }
                setLoading(false);
            })
        } catch (error) {
            setLoading(false);
        }
    }
    
    const handleFilter=(event)=>{
      const datas = itemsListFilter?.filter(row => row.NomSecteur.toLowerCase().includes(event.target.value.toLowerCase() )  )  ;
      setItemsList(datas);
    }

    const handleFilterCcl=(event)=>{
      const datas = itemsListFilterCcl?.filter(row => row?.NomCommercial?.toLowerCase().includes(event.target.value.toLowerCase() ) || row.COMMERCIAL_MSISDN?.toLowerCase().includes(event.target.value.toLowerCase()) )  ;
      setItemsListCcl(datas);
    }

    const conditionalRowStyles = [
        {
          when: row => row.EstPrincipal == "NON", // La condition pour colorer la ligne
          style: {
            backgroundColor: 'rgba(255, 0, 0, 0.1)',
            color: 'red',
            '&:hover': {
              cursor: 'pointer',
            },
          },
        },
    ];

    const chanhePageFunction=(row)=>{
        setNewComponent('detail');
       setItem(row);
        
    }
    return (
        <>
            <ContentPage>
            <div class="page-header flex-wrap">
                    <div class="header-right d-flex flex-wrap mt-md-2 mt-lg-0">
                        <div class="d-flex align-items-center">
                        <a href="#">
                            <p class="m-0 pr-3 fs-4">Page</p>
                        </a>
                        <a class="pl-3 mr-4" href="#">
                            <p class="m-0 fs-4">Performance MOMO LOCALITE/COMMERCIAL</p>
                        </a>
                        </div>
                        
                    </div>

                    <div class="header-left">
                        {/* <Link class="btn btn-primary mb-2 mb-md-0 mr-2" to="/parametres/add-commercial"> Ajouter un commercial</Link> */}
                        {/* <button class="btn btn-outline-primary mb-2 mb-md-0"> Import documents </button> */}
                    </div>
              
            </div>

            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                <div class="card-header">
                      {/* <div class="row">
                          <div class=" col-lg-3 col-md-6">
                              <input type="search" class="form-control " placeholder="Recherche..." onChange={handleFilter}/>
                          </div>
                          <div class=" col-lg-6 col-md-6">
                            <ExportExcel excelData={itemsList} filename={"LISTE DES COMMERCIAUX"}  title={"Télécharger"} color={"btn-success"}/>
                          </div>
                  </div> */}
                  </div>
                  <div class="card-body">
                        <h4 class="card-title">Performances MOMO</h4>
                        <nav>
                          <div class="nav nav-tabs" id="nav-tab" role="tablist">
                            <button class={activeClass== "ccl"? "nav-link col-6 fw-bold bg-success active" : "nav-link col-6 fw-bold"} id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" onClick={()=>setActiveClass('ccl')}>COMMERCIAUX</button>
                            <button class={activeClass== "localite"? "nav-link col-6 fw-bold bg-success active" : "nav-link col-6 fw-bold"} id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" onClick={()=>setActiveClass('localite')}>LOCALITE</button>
                          </div>
                        </nav>
                        <div class="tab-content" id="nav-tabContent">
                          <div class="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                          

               
                  <div class="accordion p-3" id="accordionExample">                 
                  <div class="row">
                          <div class=" col-lg-3 col-md-6">
                              <input type="search" class="form-control border-2" placeholder="Recherche commercial..." onChange={handleFilterCcl}/>
                          </div>
                          <div class=" col-lg-6 col-md-6">
                            <ExportExcel excelData={itemsListCcl} filename={"LISTE DES COMMERCIAUX"}  title={"Télécharger"} color={"btn-info text-dark"}/>
                          </div>
                  </div>
                              
                     <div class="card-body pb-3 border" >
                      <div class="table-responsive">
                        <table class="table table-striped">
                          <thead> 
                            <tr className="bg-info">
                              <th>COMMERCIAL</th>
                              <th>NUMERO</th>
                              <th>ACTUAL WEEK</th>
                              <th>PREVIOUS WEEK</th>
                              <th  className="text-center">WoW</th>
                              <th  className="text-center">MTD ACTUAL</th>
                              <th  className="text-center">MTD PREVIOUS</th>
                              <th  className="text-center">MoM</th>
                              <th>MTD TARGET</th>
                              <th>ACTUAL VS MTD TARGET</th>
                            </tr>
                          </thead>
                          <tbody>
                          {loading &&
                            <div class="text-center">
                            <div class="spinner-border" role="status">
                              {/* <span class="visually-hidden">Loading...</span> */}
                            </div>
                          </div>
                            }
                          {!loading ? itemsListCcl.map((row,index)  => (
                            <tr key={index} className={row.COMMERCIAL_MSISDN === "AUCUN COMMERCIAL AFFECTE" ? "":""}>
                              <td class="py-1 fw-bold">{row.NomCommercial}</td>
                              <td class="py-1 fw-bold">{row.COMMERCIAL_MSISDN}</td>
                              <td className="text-center fw-bold">{separateNumber(row.current_week_performance)}</td>
                              <td className="text-center fw-bold"> {separateNumber(row.last_week_performance)} </td>
                              <td className="text-center">
                                {row.current_week_performance > row.last_week_performance && <i class="fa-solid fa-arrow-up text-success"></i>}
                                {row.current_week_performance < row.last_week_performance && <i class="fa-solid fa-arrow-down text-danger"></i>}
                                {row.current_week_performance == row.last_week_performance && <i class="fa-solid fa-minus"></i>}
                                <b className="mx-1">
                                  {row.current_week_performance == 0 && row.last_week_performance==0 ?
                                  0.00
                                  :((row.current_week_performance-(row.last_week_performance))/(row.last_week_performance+1)).toFixed(2)
                                  }
                                </b>
                              </td>
                              <td className="text-center fw-bold">{separateNumber(row.current_month_performance)}</td>
                              <td className="text-center fw-bold"> {separateNumber(row.last_month_performance)} </td>       
                              <td className="text-center">
                                {row.current_month_performance > row.last_month_performance && <i class="fa-solid fa-arrow-up text-success"></i>}
                                {row.current_month_performance < row.last_month_performance && <i class="fa-solid fa-arrow-down text-danger"></i>}
                                {row.current_month_performance == row.last_month_performance && <i class="fa-solid fa-minus"></i>}
                                <b className="mx-1">
                                  {row.current_month_performance == 0 && row.last_month_performance==0 ?
                                  0.00
                                  :((row.current_month_performance-(row.last_month_performance))/(row.last_month_performance+1)).toFixed(2)
                                  }
                                </b>
                              </td>                    
                              <td className="text-center fw-bold">{separateNumber((((row.ObjectifCashIn+row.ObjectifCashOut+1)/31)*25).toFixed(0))}</td> 
                              <td className="text-center">
                                {(row.ObjectifCashIn+row.ObjectifCashOut+1) > (((row.ObjectifCashIn+row.ObjectifCashOut+1)/31)*25).toFixed(0) && <i class="fa-solid fa-arrow-up text-success"></i>}
                                {(row.ObjectifCashIn+row.ObjectifCashOut+1) < (((row.ObjectifCashIn+row.ObjectifCashOut+1)/31)*25).toFixed(0) && <i class="fa-solid fa-arrow-down text-danger"></i>}
                                {(row.ObjectifCashIn+row.ObjectifCashOut+1) == (((row.ObjectifCashIn+row.ObjectifCashOut+1)/31)*25).toFixed(0) && <i class="fa-solid fa-minus"></i>}

                                <b className="mx-1">{(((row.ObjectifCashIn+row.ObjectifCashOut+1)-(((row.ObjectifCashIn+row.ObjectifCashOut+1)/31)*25))/(((row.ObjectifCashIn+row.ObjectifCashOut+1)/31)*25))}</b>
                                </td>
                            </tr> )) :   (!loading && <p>Aucun commercial trouvé.</p>)}
                          </tbody>
                        </table>
                      </div>
                    </div> 

                  
              
                </div>
                          </div>
                          <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">

                          <div class="card-body pb-3 border" >
                          <div class="row">
                          <div class=" col-lg-3 col-md-6">
                              <input type="search" class="form-control border-2" placeholder="Recherche localite..." onChange={handleFilter}/>
                          </div>
                          <div class=" col-lg-6 col-md-6">
                            <ExportExcel excelData={itemsList} filename={"LISTE LOCALITE"}  title={"Télécharger"} color={"btn-info text-dark"}/>
                          </div>
                      <div class="table-responsive">
                        <table class="table table-striped">
                          <thead> 
                            <tr className="bg-info">
                              <th>LOCALITE</th>
                              <th>ACTUAL WEEK</th>
                              <th>PREVIOUS WEEK</th>
                              <th  className="text-center">WoW</th>
                              <th  className="text-center">MTD ACTUAL</th>
                              <th  className="text-center">MTD PREVIOUS</th>
                              <th  className="text-center">MoM</th>
                              <th>MTD TARGET</th>
                              <th>ACTUAL VS MTD TARGET</th>
                            </tr>
                          </thead>
                          <tbody>
                          {loading &&
                            <div class="text-center">
                            <div class="spinner-border" role="status">
                              {/* <span class="visually-hidden">Loading...</span> */}
                            </div>
                          </div>
                            }
                          {!loading ? itemsList.map((row,index)  => (
                            <tr key={index} className={row.NomSecteur == "AUTRES" ? "":""}>
                              <td class="py-1 fw-bold">{row.NomSecteur}</td>
                              <td className="text-center fw-bold">{separateNumber(row.current_week_performance)}</td>
                              <td className="text-center fw-bold"> {separateNumber(row.last_week_performance)} </td>
                              <td className="text-center">
                                {row.current_week_performance > row.last_week_performance && <i class="fa-solid fa-arrow-up text-success"></i>}
                                {row.current_week_performance < row.last_week_performance && <i class="fa-solid fa-arrow-down text-danger"></i>}
                                {row.current_week_performance == row.last_week_performance && <i class="fa-solid fa-minus"></i>}
                                <b className="mx-1">
                                  {row.current_week_performance == 0 && row.last_week_performance==0 ?
                                  0.00
                                  :((row.current_week_performance-(row.last_week_performance))/(row.last_week_performance+1)).toFixed(2)
                                  }
                                </b>
                              </td>
                              <td className="text-center fw-bold">{separateNumber(row.current_month_performance)}</td>
                              <td className="text-center fw-bold"> {separateNumber(row.last_month_performance)} </td>       
                              <td className="text-center">
                                {row.current_month_performance > row.last_month_performance && <i class="fa-solid fa-arrow-up text-success"></i>}
                                {row.current_month_performance < row.last_month_performance && <i class="fa-solid fa-arrow-down text-danger"></i>}
                                {row.current_month_performance == row.last_month_performance && <i class="fa-solid fa-minus"></i>}
                                <b className="mx-1">
                                  {row.current_month_performance == 0 && row.last_month_performance==0 ?
                                  0.00
                                  :((row.current_month_performance-(row.last_month_performance))/(row.last_month_performance+1)).toFixed(2)
                                  }
                                </b>
                              </td>                    
                              <td className="text-center fw-bold">{separateNumber((((row.ObjectifCashIn+row.ObjectifCashOut+1)/31)*25).toFixed(0))}</td> 
                              <td className="text-center">
                                {(row.ObjectifCashIn+row.ObjectifCashOut+1) > (((row.ObjectifCashIn+row.ObjectifCashOut+1)/31)*25).toFixed(0) && <i class="fa-solid fa-arrow-up text-success"></i>}
                                {(row.ObjectifCashIn+row.ObjectifCashOut+1) < (((row.ObjectifCashIn+row.ObjectifCashOut+1)/31)*25).toFixed(0) && <i class="fa-solid fa-arrow-down text-danger"></i>}
                                {(row.ObjectifCashIn+row.ObjectifCashOut+1) == (((row.ObjectifCashIn+row.ObjectifCashOut+1)/31)*25).toFixed(0) && <i class="fa-solid fa-minus"></i>}

                                <b className="mx-1">{(((row.ObjectifCashIn+row.ObjectifCashOut+1)-(((row.ObjectifCashIn+row.ObjectifCashOut+1)/31)*25))/(((row.ObjectifCashIn+row.ObjectifCashOut+1)/31)*25))}</b>
                                </td>
                            </tr> )) :   (!loading && <p>Aucun commercial trouvé.</p>)}
                          </tbody>
                        </table>
                      </div>
                    </div> 
                          </div>
                         </div>
                    
                        </div>
                         
{/*
                        {newComponent == 'detail' && 
                            <DetailSitesPage rowItem={item} />
                        }
                     */}
                  </div>
                </div>
              </div>
            </ContentPage>
        </>
    );

}

export default PerformanceMomo;